module.exports = __webpack_public_path__ + "static/media/one.40e41fa9.jpg";